var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnosisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m20.362 7l.19.3A9.5 9.5 0 0 1 22 12.336c.01 2.546-1.036 4.992-2.91 6.803S14.666 21.979 12 22h-.019c-5.505 0-10-4.364-9.98-9.7a9.4 9.4 0 0 1 1.466-5.036l.171-.273l.915.881a3.4 3.4 0 0 0-.43.82a3.56 3.56 0 0 0 .135 2.826a3.83 3.83 0 0 0 2.18 1.919a4 4 0 0 0 1.766.181a3.94 3.94 0 0 0 1.663-.6L12 15.091l2.438-2.363a3.9 3.9 0 0 0 3.234.373a3.8 3.8 0 0 0 1.418-.843a3.55 3.55 0 0 0 1.087-2.982a3.5 3.5 0 0 0-.577-1.549zM5.676 8.954l2.867 2.764c-.353.277-.79.425-1.238.419a2.1 2.1 0 0 1-1.446-.585a1.92 1.92 0 0 1-.592-1.388c0-.455.152-.873.41-1.21m10 2.592l2.838-2.737c.22.318.343.7.343 1.1c0 1.091-.915 1.973-2.038 1.973c-.428 0-.81-.119-1.143-.336m-3.638 2.072L3.781 5.591l.324-.327a10.6 10.6 0 0 1 3.546-2.415A11 11 0 0 1 11.914 2h.02c3.018 0 5.923 1.254 7.942 3.428l.315.336zM5.124 5.591l6.914 6.709l6.819-6.573a9.8 9.8 0 0 0-3.159-2.056c-1.19-.48-2.462-.73-3.745-.735h-.02c-2.571 0-4.971.937-6.81 2.655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnosisLogo);
export default __webpack_public_path__ + "static/media/gnosis-logo.9220c30f8f4a8a7bf055b09ffc636663.svg";
export { ForwardRef as ReactComponent };